
export class ManualRunQCReviewRequest {
  labId: string;
  runId: string;
  puid: string;
  laneId: string;
  runQcStatusList: ManualRunQCEventPayload[];
  allLib: string[];
  updaterunFlag: boolean;
  currentDateTime: Date;
  runReviewStarted: boolean;
  runQCAction: string;
  ontRun: boolean;
  sequencerType: string;
}

export class ManualRunQCEventPayload {
  libraryBarcode: string;
  labName: string;
  lane: string;
  containerLibraryBarcode: string;
  run: string;
  runQCStatus: string;
  reportVersion: string;
  sequencerType: string;
}
